let _ = t => t,
  _t;
import styled from 'styled-components';
import { colors } from '@ovpn-ui/styles';
export const Mark = styled.mark(_t || (_t = _`
    display: inline-block;

    background-color: ${0};
`), colors.primaryLightHover);